import Axios from '@/api/http'

/**
 * 提交评论
 * */
export function openapiReview(date) {
  return Axios({
    method: 'post',
    url: '/openapi/review',
    data: date
  })
}

/**
 * 获取评论预置数据
 * */
export function openapiGetcommonlanguagelist(date) {
  return Axios({
    method: 'post',
    url: '/openapi/getcommonlanguagelist',
    data: date
  })
}

/**
 * 新增、删除常用语
 * */
export function openapiAddcommonlanguage(date) {
  return Axios({
    method: 'post',
    url: '/openapi/addcommonlanguage',
    data: date
  })
}

/**
 * 审批同意、拒绝按钮、转办
 * */
export function openapiUpdateuserapproving(date) {
  return Axios({
    method: 'post',
    url: '/openapi/updateuserapproving',
    data: date
  })
}

/**
 * 流转
 * */
export function openapiUpdatetransactor(date) {
  return Axios({
    method: 'post',
    url: '/openapi/updatetransactor',
    data: date
  })
}
